import { commonHttpClient } from './commonHttpClient';
import { User } from '../../utils/interfaces/User';

const { http } = commonHttpClient();

export const getUserDetailInfo = async (uid: number): Promise<User> => {
  const { data } = await http.get(`/users/${uid}`);
  return data as User;
};
